$(function() {
    // on defini ici les paramètres du moteur + le context
    bhmoteur.configure({
        url: 'https://shopify.livrenpoche.com:3004/search',
        debug: false,
        q_field: 's',
        moteur: {
          limit: 48,
        }
    });

    // pour les recommandation
    $(".moteur_bh_recommandation").each(function() {
      const bhmoteurRecommandation = new BHMoteur();
      bhmoteurRecommandation.configure({
          url: bhmoteur.getParams().url,
          debug: bhmoteur.getParams().debug,
          q_field: bhmoteur.getParams().q_field,
          moteur: {
            limit: bhmoteur.getParams().moteur.limit,
          }
      });

      const _this = this;
      var params = {
          q: '',
          fieldsReturn: "",
          search_collections: false,
          order_by: 'nouveaute',
          order_by_sens: 'desc',
          debug: true,
          limit:4,

          group_by:"",
          exclude:"",
          q_filter_m:"",
          q_fuzziness:"true",
          q_strict:"false",
          q_strict_prefix:"true",
      }
      for (var k in params) {
          if($(_this).attr(k) != undefined) {
              const attrValue = $(_this).attr(k);
              if(k == "q_filter_m" && attrValue != "") {
                  try {
                      const dataJsonStr = attrValue.replace(/'/g, '"');
                      params[k] = JSON.parse(dataJsonStr);
                  } catch (e) {
                      /* empty */
                      console.log(e);
                  }

              } else {
                  params[k] = attrValue;
              }              
          }
      }
      bhmoteurRecommandation.BHMoteurRecommandationSearch(
        $(_this).attr("id"), 
        params, 
        {
            idTagTemplate: "template_moteur_bh_produit_recommandation", // id script template nunjucks
            idTagTarget: $(_this).attr("id"), // id cible pour l'intertion du code
        }, 
        function(dataResult) {
          if(dataResult.result.data_count == 0 || dataResult.result.data.length == 0) {
              $(_this).remove();
          } else {
            $(_this).find("h2.related-products__heading").html($(_this).attr("title"));
          }
        },
        function(onLoadingCallback) {
            // console.log('onLoadingCallback BHMoteurAutoCompleteSearch', onLoadingCallback);
        },
        function(err) {
            console.log('onErrorCallback BHMoteurAutoCompleteSearch', err);
        } 
      );  
  });  
});